/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Proofreading API
 * PR TIMES 校正 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProofreadingResultMessage,
    ProofreadingResultMessageFromJSON,
    ProofreadingResultMessageFromJSONTyped,
    ProofreadingResultMessageToJSON,
} from './ProofreadingResultMessage';

/**
 * POST /main
 * @export
 * @interface ProofreadingMainResponse
 */
export interface ProofreadingMainResponse {
    /**
     * 
     * @type {number}
     * @memberof ProofreadingMainResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ProofreadingMainResponse
     */
    message: string;
    /**
     * 校正結果リスト (リクエストで送信した bulk_text の結果が順番に格納される)
     * @type {Array<Array<ProofreadingResultMessage>>}
     * @memberof ProofreadingMainResponse
     */
    results: Array<Array<ProofreadingResultMessage>>;
}

export function ProofreadingMainResponseFromJSON(json: any): ProofreadingMainResponse {
    return ProofreadingMainResponseFromJSONTyped(json, false);
}

export function ProofreadingMainResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProofreadingMainResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'results': json['results'],
    };
}

export function ProofreadingMainResponseToJSON(value?: ProofreadingMainResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'results': value.results,
    };
}

